module.exports = __webpack_public_path__ + "static/media/portfolio1 (17).17500e1a.jpeg";